import SaveAsImage from './SaveAsImage';

export default SaveAsImage;
